import { createListResource } from "../../list";

export const searchSuggestionResource =
  createListResource("search/suggestion/");
